export default __webpack_public_path__ + "2d5b9c134b21c70a4f81632a3142130b.png";